/**
 * All API types should contain at least the properties:
 * self: The URL to the API endpoint that can be used to fetch the instance.
 * id: The PK of the instance. Not available on all API types.
 */
export type EntityBaseType = {
  self: string,
  id?: number,
}

export enum HTTPMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export interface WebsocketMessage {
  type: string,
  data: {[key: string]: any}
}

/**
 * Keyword arguments for API fetch functions.
 * onSuccess: Callback function that is executed every time a response is received.
 * onFinal: Callback function that is executed *after* calling onSuccess for the last time.
 * onError: Callback function that is executed every time an error is received.
 * parameter: URL parameter, e.g. 'expand=supplier,article', 'exclude=id'
 * url: The URL that specifies the API endpoint to request.
 */
export interface FetchKwargs<T> {
  onSuccess: (response: T[], count?: number) => void,
  onFinal?: () => void,
  onError?: (error: any) => void,
  parameter?: string[],
  url?: string
  headers?: {[key: string]: string}
}

export interface FetchKwargsSingle<T> {
  onSuccess: (response: T) => void,
  onError?: (error: any) => void,
  parameter?: string[],
  url?: string
  headers?: {[key: string]: string}
}